import Glide from '@glidejs/glide';

export function slideCarouselSetup() {
  console.log('slideCarouselSetup');
  // searches for a slide block  to attach to, if none found returns
  var slideGlide = document.querySelector(".slideshow-glide");

  if(!slideGlide){
    return;
  }

  // creates Glide instance
  let glide = new Glide(slideGlide, {
    hoverpause: true,
    type: 'carousel',
    // breakpoints: {
    //   500:{
    //     autoplay: false
    //   }
    // }
  });

  // start autoplay when block enters view, stop on exit
  let observer = new IntersectionObserver(function (entries, observer) {
    for (let entry of entries) {
      // console.log('the element', entry.target);
      // console.log('is intersecting', entry.isIntersecting);
      if(entry.isIntersecting){
        console.log('start autoplay');
        glide.update({
          autoplay: 6000,
        });
      }else{
        console.log('stop autoplay');
        glide.update({autoplay: false});
      }
    }
  });

  observer.observe(slideGlide);

  glide.on('run.after', async function() {
    var active = document.querySelector(".glide__slide--active");
    // console.log('run.after', active);

    var videoElem = active.querySelector('video');
    if(videoElem){
      glide.update({autoplay: false});
      console.log('Enter video slide!');
      await videoElem.play();

      videoElem.addEventListener("ended", (event) => {
        console.log("Video ended");
        glide.go('>');
        glide.update({ autoplay: 6000, });
      });
    }
  });

  glide.on('run.before', async function() {
    var active = document.querySelector(".glide__slide--active");
    // console.log('run.before', active);

    var videoElem = active.querySelector('video');
    if(videoElem){
      console.log('Exit video slide!');
      videoElem.pause();
    }
  });

  // starts the instance
  glide.mount();
}